import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

// Connects to data-controller="popover"
export default class extends Controller {
  static targets = ["hover", "content"]

  connect() {
    this.displayed = false;
    this.popover = new Popover(this.hoverTarget, {
      content: this.contentTarget.innerHTML,
      html: true,
      trigger: "manual",
      customClass: "popover-email",
    });
    this.hoverTarget.addEventListener("mouseenter", this.show.bind(this));
    document.addEventListener("click", this.handleDocumentClick.bind(this));
    this.element.addEventListener("click", this.stopPropagation);
  }

  show() {
    if (!this.displayed) {
      this.popover.show();
      this.displayed = true;
      setTimeout(this.hide.bind(this), 5000);
    }
  }

  hide() {
    if (this.displayed) {
      this.popover.hide();
      this.displayed = false;
    }
  }

  handleDocumentClick(event) {
    if (this.displayed && !this.element.contains(event.target) && !this.contentTarget.contains(event.target)) {
      this.hide();
    }
  }

  disconnect() {
    this.popover.dispose();
    document.removeEventListener("click", this.handleDocumentClick.bind(this));
    this.element.removeEventListener("click", this.stopPropagation);
  }
}
